import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar } from 'antd'
import store from 'store'
import { history } from 'index'
import Cookies from 'js-cookie'
import { getUserDetailedInfo } from 'redux/user/actions'
import { capitalizeFirstLetter } from 'utils'
import styles from './style.module.scss'

const mapStateToProps = ({ user }) => ({ user })

const ProfileMenu = ({ user, dispatch }) => {
  const logout = (e) => {
    e.preventDefault()
    // Clear all auth-related cookies
    Cookies.remove('accessToken')
    Cookies.remove('userData')
    Cookies.remove('userInfo')
    Cookies.remove('userEmail')
    Cookies.remove('features')
    
    history.push('/auth/login')
    store.set('app.menu.openedKeys', [])
    store.set('app.menu.selectedKeys', [])
  }

  const userId = user?.userInfo?.userId

  useEffect(() => {
    // First, restore user info from cookies if Redux state is empty
    if (!user?.userInfo?.email) {
      const storedUserInfo = Cookies.get('userInfo')
      const storedUserData = Cookies.get('userData')
      const storedUserEmail = Cookies.get('userEmail')
      
      if (storedUserInfo) {
        try {
          const userInfo = JSON.parse(storedUserInfo)
          dispatch({
            type: 'USER_SET_STATE',
            payload: { 
              userInfo,
              planFeatures: userInfo.features || [],
              customerInfo: {
                id: userInfo.customerId,
                name: userInfo.customerName,
                plan: userInfo.plan
              }
            }
          })
        } catch (error) {
          console.error('Error parsing stored user info:', error)
        }
      } else if (storedUserData) {
        // Fallback to userData cookie if userInfo is not available
        try {
          const userData = JSON.parse(storedUserData)
          const userInfo = {
            userId: userData.user_id,
            username: userData.username,
            customerId: userData.customer_id,
            customerName: userData.customer_name,
            userRole: userData.userRole || userData.user_role,
            userRoleId: userData.userRoleId || userData.user_role,
            empId: userData.empId,
            email: userData.email || storedUserEmail,
            isConcernPerson: userData.isConcernPerson,
            depId: userData.depId,
            locationId: userData.locationId,
            features: userData.plan?.features?.map(f => f.module_key) || [],
            plan: userData.plan
          }
          
          dispatch({
            type: 'USER_SET_STATE',
            payload: { 
              userInfo,
              planFeatures: userInfo.features,
              customerInfo: {
                id: userData.customer_id,
                name: userData.customer_name,
                plan: userData.plan
              }
            }
          })
        } catch (error) {
          console.error('Error parsing stored user data:', error)
        }
      }
    }

    // Then fetch detailed user info if userId is available
    if (userId) {
      const fetchUserDetails = async () => {
        try {
          await dispatch(getUserDetailedInfo(userId))
        } catch (error) {
          console.log(error)
        }
      }
      fetchUserDetails()
    }
  }, [dispatch, userId, user?.userInfo?.email])

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <strong>
          <FormattedMessage id="topBar.profileMenu.hello" />,{' '}
          {(user?.userDetailedInfo?.userName &&
            capitalizeFirstLetter(user?.userDetailedInfo?.userName)) ||
            user?.userInfo?.username ||
            'Anonymous'}
        </strong>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.email" />:{' '}
          </strong>
          {user?.userInfo?.email || Cookies.get('userEmail') || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a href="/profile">
          <i className="fe fe-user mr-2" />
          <FormattedMessage id="topBar.profileMenu.editProfile" />
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={logout}>
          <i className="fe fe-log-out mr-2" />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div className={styles.dropdown} id="profile">
        <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
      </div>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(ProfileMenu)